import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {KnowledgeEntityTypeEnum} from '../../util/uiconstants';
import _ from 'lodash';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function canvasFormRelatedObjectsReducer(state = initialState.canvasFormRelatedObjects, action) {
	switch (action.type) {
		case types.GET_CANVASFORM_RELATED_OBJECTS: {
			let {allObjects, ...newState} = state;
			if(action.response?.data){
				newState.allObjects = formatObjects(action.response.data, action.objectType);
			} else {
				newState.allObjects = formatObjects(action.response, action.objectType);
			}
			return newState;
		}
		case types.ADD_CANVASFORM_RELATED_OBJECT: {
			let {selectedObjects, allObjects, ...newState} = state;
			let objects = [...selectedObjects];
			let index = allObjects.findIndex((object) => object.id === action.item.id);
			if (index !== -1 && action.checked) {
				objects.push({...action.item});
			} else {
				index = allObjects.children?.findIndex((object) => object.id === action.item.id);
				if (index !== -1 && action.checked) {
					objects.push({...action.item});
				}
			}
			newState.selectedObjects = objects;
			newState.allObjects = [...allObjects];
			return newState;
		}
		case types.REMOVE_CANVASFORM_RELATED_OBJECT: {
			let {selectedObjects, allObjects, ...newState} = state;
			let objects = [...selectedObjects];
			let index = objects.findIndex((object) => object.id === action.id);
			if (index !== -1) {
				objects.splice(index, 1);
			}

			newState.selectedObjects = objects;
			newState.allObjects = [...allObjects];
			return newState;
		}
		case types.RESET_OBJECT_SELECTION: {
			let {selectedObjects, ...newState} = state;
			newState.selectedObjects = [];
			return newState;
		}
		case types.CLOSE_CANVAS_FORM_COMBINED: {
			let {selectedObjects, ...newState} = state;
			newState.selectedObjects = [];
			return newState;
		}
		case types.RESET_OBJECT_LIST: {
			let {allObjects, ...newState} = state;
			newState.allObjects = [];
			return newState;
		}
		default:
			return state;
	}
}

// function formatObjects(response, objectType) {
// 	let canvasFormObject = {totalCount: response.totalEntityCount};
// 	canvasFormObject.availablePages = response.pages;

// 	if (response && response.data && response.data.length > 0) {
// 		canvasFormObject.currentPage = response.page;
// 		canvasFormObject.list = mapScotToObject(response.data, objectType);
// 	} else {
// 		canvasFormObject.currentPage = 0;
// 		canvasFormObject.availablePages = 0;
// 		canvasFormObject.list = [];
// 	}
// 	return canvasFormObject;
// }

function formatObjects(data, objectType) {
	let objects = [];
	switch (objectType) {
		case KnowledgeEntityTypeEnum.SCOT: {
			_.forEach(data, (item) => {
				objects.push({id: item.id, name: item.scotName});
			});
			break;
		}
		case KnowledgeEntityTypeEnum.ITProcess: {
			_.forEach(data, (item) => {
				objects.push({id: item.id, name: item.itProcessName});
			});
			break;
		}
	}
	return objects;
}
